<template>
  <div v-frag>
    <v-card 
      class="rounded-xl text-center d-flex flex-column justify-center" 
      color="white" 
      elevation="0" 
      @click="$emit('press')" 
      height="200" 
      width="100%"
      style="padding: 16px;"
    >
      <!-- Icono en su tamaño original -->
      <v-icon size="80" class="mb-3" color="modify">{{ icon }}</v-icon>

      <div>
        <!-- Chip NUEVO si aplica -->
        <v-chip class="ma-1" label color="red" text-color="white" v-if="newOption" style="font-size: 0.7rem;">
          NUEVO
        </v-chip>
        
        <!-- Texto con tamaño y menor interlineado -->
        <span class="text-modify" style="color: #013e6e; font-size: 1em; line-height: 1.1;">
          {{ text }}
        </span>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "CardIeaCategory",
  props: ["text", "icon", "color", "newOption"],
};
</script>

<style scoped>
.v-card {
  padding: 16px; /* Padding interno general en la tarjeta */
}
.v-icon {
  font-size: 80px !important; /* Tamaño original del icono */
}
.text-modify {
  font-size: 2.5rem; /* Texto más pequeño */
  line-height: 1.1; /* Menor interlineado para reducir espacio entre líneas */
  font-weight: bold;
}
</style>
